import _ from 'underscore';
import { showSuccess as success } from '@bingads-webui-component-legacy/toast/index';
import { MultiLanguageSelector } from '@bingads-webui-campaign/multi-language-selector';

import globalConfig from '@bingads-webui-component-legacy/config/index';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import template from '@bingads-webui-campaign-legacy/campaign-bulk-edit/template/bulkEditLanguage.pug';
import ViewModel from '@bingads-webui-campaign-legacy/campaign-bulk-edit/viewmodel/bulkEditLanguage';

const s$AdGroup = window.globalLegacySchema.get('AdGroup');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

const {
  IsSimplifiedChineseLanguageEnabledInMultipleLanguage,
  IsAdsGlobalizationPhase1Enabled,
  IsAdsGlobalizationPhase2Enabled,
  IsAdsGlobalizationPhase6Enabled,
  IsAdsGlobalizationPhase2JapanEnabled,
  IsDomesticSimplifiedChineseEnabled,
  IsAdsGlobalizationPhase9Enabled,
  IsAdsGlobalizationPhase9VIEnabled,
} = globalConfig.get('Permissions');

export default class View extends BaseView {
  initialize(options) {
    super.initialize(options);
    this.template = template;
    // eslint-disable-next-line camelcase
    this.ko_model = new ViewModel(this.model);
    this.languageSelector = null;
    this.onOperationSuccess = () => {
      if (this.selectionAcrossPage()) {
        success(i18n.getString('campaign_language_association_success'));
      } else {
        success(i18n.getString('campaign_language_association_success_for_selected_campaigns'));
      }
      this.deselectAll();
    };
  }

  render(options) {
    super.render(options);
    let languages = _.without(s$AdGroup.properties.Language.enum, 'None');

    if (!IsAdsGlobalizationPhase1Enabled) {
      languages = _.without(languages, 'Greek', 'Polish', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Romanian', 'Slovak', 'Slovenian');
    }

    if (!IsAdsGlobalizationPhase2Enabled) {
      languages = _.without(languages, 'Turkish', 'Serbian', 'Bosnian', 'Albanian', 'Macedonian', 'Icelandic');
    }

    if (!IsAdsGlobalizationPhase6Enabled) {
      languages = _.without(languages, 'Hebrew', 'Arabic', 'Russian');
    }

    if (!IsAdsGlobalizationPhase2JapanEnabled) {
      languages = _.without(languages, 'Japanese');
    }

    if (!IsAdsGlobalizationPhase9Enabled) {
      languages = _.without(languages, 'Hindi', 'Malay', 'Thai', 'Indonesian', 'Tagalog');
    }

    if (!IsAdsGlobalizationPhase9VIEnabled) {
      languages = _.without(languages, 'Vietnamese');
    }

    const languageOptions = {
      languages: _.sortBy(languages), // sort languages
      inEditMode: true,
      selectedLanguages: this.ko_model.selectedLanguages(),
      i18n,
    };

    if (!IsSimplifiedChineseLanguageEnabledInMultipleLanguage) {
      languageOptions.languages = _.without(languageOptions.languages, 'SimplifiedChinese');
    }

    if (IsDomesticSimplifiedChineseEnabled) {
      languageOptions.languages = ['SimplifiedChinese'];
    }

    this.languageSelector = new MultiLanguageSelector(languageOptions);

    this.$('.language-selector-container').html(this.languageSelector.render().el);

    this.languageSelector.on('selectedLanguages:changed', () => {
      this.ko_model.selectedLanguages(this.languageSelector.getSelectedLanguages());
    });

    return this;
  }

  setAction() {
    const action = {
      Actions: [{
        '@odata.type': '#Model.TextAction',
        Property: 'Languages',
        ActionType: 'Set',
        Value: JSON.stringify(this.ko_model.selectedLanguages()),
        SearchString: '',
        Options: 'None',
      }],
    };

    this.model.set('BatchAction', action);
    this.model.set('Entity', 'Campaign');
  }

  selectionAcrossPage() {
    const { grid } = this.options;
    const { pgridPlugins } = grid;

    return pgridPlugins &&
      pgridPlugins.crossPageSelectAll &&
      pgridPlugins.crossPageSelectAll.isAllSelected;
  }

  deselectAll() {
    if (this.selectionAcrossPage()) {
      this.options.grid.pgridPlugins.crossPageSelectAll.deselectAll();
    } else {
      this.options.grid.gridView.deselectAll();
    }
  }

  getIdFilter() {
    return filterHelper.getIdFilter(this.grid, 'Campaign');
  }

  getProgressText() {
    return i18n.getString('BulkEdit_Campaigns_ProgressText');
  }

  formatPreviewOrError(rows) {
    // returned values are in this format "[\"English\",\"French\"]"
    // update it to English, French, with localization
    const getLanguageString = (returnedValue) => {
      if (returnedValue) {
        const languages =  returnedValue.replace(/\[|\]|"/g, '').split(',');

        return _.map(languages, (lang) => {
          return i18n.getString(`Language_${lang}`);
        }).join(', ');
      }
      return returnedValue;
    };

    if (rows) {
      _.each(rows, (value) => {
        value.Entity = _.find(value.EntityKey, (item) => {
          return item.Key === 'CampaignName';
        });

        value.data = [];
        value.data.push({value: value.Entity && value.Entity.Value ? value.Entity.Value : '', isHtml: false});

        if (value.Changes && value.Changes.length) {
          //for changeBid we can only have one element in value.Changes array
          value.data.push({value: getLanguageString(value.Changes[0].OriginalValue), isHtml: false});
          value.data.push({value: getLanguageString(value.Changes[0].NewValue), isHtml: false});
        } else {
          value.data.push({value: '', isHtml: false});
          value.data.push({value: '', isHtml: false});
        }
      });
    }
    return rows;
  }

  formatErrors(errors) {
    return this.formatPreviewOrError(errors);
  }

  formatPreviewResults(results) {
    return this.formatBid(results);
  }
}
